import React from "react";
import styles from "./statistics-overview.module.css";
import StatisticsCard from "../../../../components/statistics-card/statistics-card";

const HolidayStatisticsOverview = ({ overviewStatistics, loading = false }) => {
  const overview_statistics = [
    {
      icon_name: "calendar-icon",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Total Working Days",
      card_bg_color: "#F2FFF4",
      icon_container_bg_color: "#29C241",
      statistic_value: overviewStatistics?.totalWorkingDays ?? "0",
    },
    {
      icon_name: "calendar-icon",
      icon_fill: "transparent",
      icon_stroke: "#fff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Total Holidays",
      card_bg_color: "#E7F8FF",
      icon_container_bg_color: "#4BCAFF",
      statistic_value: overviewStatistics?.totalHolidays ?? "0",
    },
  ];
  return (
    <div className={styles.statistics_overview}>
      <div className={styles.statistics}>
        {overview_statistics?.map(
          ({
            icon_name,
            icon_fill,
            icon_stroke,
            icon_width,
            icon_height,
            heading_text,
            card_bg_color,
            icon_container_bg_color,
            statistic_value,
          }) => (
            <div className={styles.statistics_card}>
              <StatisticsCard
                icon_name={icon_name}
                icon_fill={icon_fill}
                icon_stroke={icon_stroke}
                icon_width={icon_width}
                icon_height={icon_height}
                heading_text={heading_text}
                card_bg_color={card_bg_color}
                icon_container_bg_color={icon_container_bg_color}
                statistic_value={statistic_value}
                loading={loading}
              />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default HolidayStatisticsOverview;
